import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { orgLoaderHandler } from "src/lib/orgLoaderHandler";
import { OrganizationWorkoutsPage } from "src/pages/OrganizationWorkoutsPage";
import { createOrganizationWorkoutsRepository } from "src/repositories/workouts/createOrganizationWorkoutsRepository";

export const ORGANIZATION_WORKOUTS_DEFAULT_PAGE_SIZE = 10;

const searchSchema = z.object({
  q: z.string().optional(),
  p: z.coerce.number().optional(),
  ps: z.coerce.number().optional(),
  labels: z.array(z.string()).optional(),
});

export const Route = createFileRoute("/_auth/_coach/orgs/$slug/workouts/")({
  component: OrganizationWorkoutsPage,
  validateSearch: searchSchema,
  ssr: true,
  loaderDeps: ({ search }) => ({
    filter: "all" as const,
    pageIndex: search.p || 0,
    pageSize: search.ps || ORGANIZATION_WORKOUTS_DEFAULT_PAGE_SIZE,
    query: search.q || "",
    labelIds: search.labels,
  }),
  async loader({ context, deps, params }) {
    return orgLoaderHandler(
      { queryClient: context.queryClient, slug: params.slug },
      async ({ organization }) => {
        const workoutsRepository = createOrganizationWorkoutsRepository(
          organization.id,
        );
        await context.queryClient.query({
          ...workoutsRepository.listOptions(deps),
          staleTime: "static",
        });
        return { data: null };
      },
    );
  },
});
